// extracted by mini-css-extract-plugin
export var darkMode = "custom-slider-module--dark-mode--x7zZ6";
export var slider = "custom-slider-module--slider--iSF-z";
export var sliderSuccessStories = "custom-slider-module--slider-success-stories--m2LDS";